import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex items-center mt-1"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm block ml-2 text-gray-400" }, "Поиск вычисления по номеру накладной...", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_loader = _resolveComponent("loader")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large DiscountActions",
    title: _ctx.modalTitle,
    "confirm-button-text": _ctx.modalConfirmButtonText,
    "confirm-button-class": _ctx.isDelete ? 'small red' : undefined,
    "confirm-message": `Вы действительно хотите удалить скидку?`,
    "is-confirm": _ctx.isDelete,
    loading: _ctx.loading,
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.emitManager
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_select, {
        placeholder: "На что выдаётся скидка",
        options: _ctx.DISCOUNT_ENTITY_TYPES,
        "select-by": "id",
        searchable: false,
        value: _ctx.state.entityType,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.entityType) = $event)),
        "is-invalid": _ctx.state_form$.entityType.$error,
        "validation-errors": _ctx.state_form$.entityType.$errors,
        onChange: _ctx.onEntityTypeChange
      }, null, 8, ["options", "value", "is-invalid", "validation-errors", "onChange"]),
      _createVNode(_component_the_select, {
        class: "mt-3",
        placeholder: "Тип скидки",
        options: _ctx.DISCOUNT_UNIT_TYPES,
        "select-by": "id",
        searchable: false,
        value: _ctx.state.unitId,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.unitId) = $event)),
        "is-invalid": _ctx.state_form$.unitId.$error,
        "validation-errors": _ctx.state_form$.unitId.$errors
      }, null, 8, ["options", "value", "is-invalid", "validation-errors"]),
      (_ctx.state.entityType === _ctx.DISCOUNT_ENTITY_TYPES[0].id)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_the_input, {
              class: "mt-2",
              placeholder: "Номер накладной",
              value: _ctx.state.invoice_number,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.invoice_number) = $event)),
              "is-invalid": _ctx.state_form$.invoice_number.$error,
              "validation-errors": _ctx.state_form$.invoice_number.$errors,
              onInput: _ctx.debouncedSearch
            }, null, 8, ["value", "is-invalid", "validation-errors", "onInput"]),
            (_ctx.state.is_calculation_loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(_component_loader, { class: "primary small" }),
                  _hoisted_2
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.state.entityType === _ctx.DISCOUNT_ENTITY_TYPES[1].id)
        ? (_openBlock(), _createBlock(_component_the_select, {
            key: 1,
            class: "mt-3",
            placeholder: "Компания",
            loading: _ctx.data_state.companies.is_loading,
            failed: _ctx.data_state.companies.is_failed,
            "is-invalid": _ctx.state_form$.company_id.$error,
            "validation-errors": _ctx.state_form$.company_id.$errors,
            "error-text": "При получении списка компаний произошла ошибка",
            options: _ctx.data_state.companies.list,
            value: _ctx.state.company_id,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.company_id) = $event)),
            "infinite-scroll": "",
            onRefresh: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadCompanies(_ctx.data_state.companies.pagination.current_page))),
            onLoadmore: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadMoreCompanies(_ctx.data_state.companies.pagination.current_page + 1))),
            onSearch: _ctx.searchCompanies,
            onOptionBySearch: _ctx.unshiftFindedCompany
          }, null, 8, ["loading", "failed", "is-invalid", "validation-errors", "options", "value", "onSearch", "onOptionBySearch"]))
        : _createCommentVNode("", true),
      (_ctx.state.unitId === _ctx.DISCOUNT_UNIT_TYPES[0].id)
        ? (_openBlock(), _createBlock(_component_the_input, {
            key: 2,
            class: "mt-2",
            placeholder: "Сумма скидки",
            value: _ctx.state.cost_amount,
            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.cost_amount) = $event)),
            "is-invalid": _ctx.state_form$.cost_amount.$error,
            "validation-errors": _ctx.state_form$.cost_amount.$errors
          }, null, 8, ["value", "is-invalid", "validation-errors"]))
        : _createCommentVNode("", true),
      (_ctx.state.unitId === _ctx.DISCOUNT_UNIT_TYPES[1].id)
        ? (_openBlock(), _createBlock(_component_the_input, {
            key: 3,
            class: "mt-2",
            placeholder: "Процент скидки",
            value: _ctx.state.percent_amount,
            "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.percent_amount) = $event)),
            "is-invalid": _ctx.state_form$.percent_amount.$error,
            "validation-errors": _ctx.state_form$.percent_amount.$errors
          }, null, 8, ["value", "is-invalid", "validation-errors"]))
        : _createCommentVNode("", true),
      _createVNode(_component_the_input, {
        class: "mt-2",
        type: "date",
        placeholder: "Дата окончания",
        value: _ctx.state.expiredAt,
        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.expiredAt) = $event)),
        min: _ctx.min_date
      }, null, 8, ["value", "min"])
    ]),
    _: 1
  }, 8, ["title", "confirm-button-text", "confirm-button-class", "is-confirm", "loading", "onCancel", "onConfirm"]))
}